export const VALID_FILE_TYPES = [
  // image
  'png',
  'jpg',
  'jpeg',
  'bmp',
  'tif',
  'tiff',
  'gif',
  'svg',
  // presentation
  'ppt',
  'pptx',
  'key',
  // document
  'docx',
  'doc',
  'pages',
  // pdf
  'pdf',
  'html',
  // text
  'txt',
  'ttf',
  // spreadsheet
  'xlsx',
  'xls',
  'numbers',
  'csv',
  // audio
  'wav',
  'mp3',
  'weba',
  'aac',
  'm4a',
  'm4b',
  'ogg',
  'oga',
  'mmf',
  'awb',
  'au',
  'vox',
  'voc',
  'tta',
  'sln',
  // video
  'mp4',
  'wmv',
  'mov',
  'avi',
  'mkv',
  'flv',
  'webm',
  'html5',
  'avchd',
  'swf',
  'm4v',
  '3gp',
  'm4p',
  'f4v',
  'f4p',
  'f4a',
  // other
  'zip',
  'rar',
  'tar',
  'gzip',
  'eps',
  'ps',
  'psd',
  'ai',
  'dxf',
  'xps',
  'xml',
  'json',
  'css',
  'php',
  'py',
  'ics',
];

export const FILE_SOURCE_MAPPING = {
  SYSTEM_FILE: 'system',
  SYSTEM_FILE_ID: 1,
  EMAIL_FILE: 'email',
  EMAIL_FILE_ID: 2,
  ZENDESK_FILE: 'zendesk',
  ZENDESK_FILE_ID: 3,
  TASK_FILE: 'task',
  TASK_FILE_ID: 4,
  INTERCOM_FILE: 'intercom',
  INTERCOM_FILE_ID: 5,
  FRESHDESK_FILE: 'freshdesk',
  FRESHDESK_FILE_ID: 6,
  JIRA_FILE: 'jira',
  JIRA_FILE_ID: 7,
  SUCCESS_PLAN_FILE: 'success_plan',
  SUCCESS_PLAN_ID: 8,
  SURVEY_EMAIL_FILE: 'email_survey',
  SURVEY_EMAIL_ID: 11,
  TICKET_FILE: 'ticket',
  TICKET_FILE_ID: 13,
};

export const fileIdSourceMap = {
  [FILE_SOURCE_MAPPING.SYSTEM_FILE_ID]: FILE_SOURCE_MAPPING.SYSTEM_FILE,
  [FILE_SOURCE_MAPPING.EMAIL_FILE_ID]: FILE_SOURCE_MAPPING.EMAIL_FILE,
  [FILE_SOURCE_MAPPING.ZENDESK_FILE_ID]: FILE_SOURCE_MAPPING.ZENDESK_FILE,
  [FILE_SOURCE_MAPPING.TASK_FILE_ID]: FILE_SOURCE_MAPPING.TASK_FILE,
  [FILE_SOURCE_MAPPING.INTERCOM_FILE_ID]: FILE_SOURCE_MAPPING.INTERCOM_FILE,
  [FILE_SOURCE_MAPPING.FRESHDESK_FILE_ID]: FILE_SOURCE_MAPPING.FRESHDESK_FILE,
  [FILE_SOURCE_MAPPING.JIRA_FILE_ID]: FILE_SOURCE_MAPPING.JIRA_FILE,
  [FILE_SOURCE_MAPPING.SUCCESS_PLAN_ID]: FILE_SOURCE_MAPPING.SUCCESS_PLAN_FILE,
  [FILE_SOURCE_MAPPING.TICKET_FILE_ID]: FILE_SOURCE_MAPPING.TICKET_FILE,
};
export const fileSourceIdMap = {
  [FILE_SOURCE_MAPPING.SYSTEM_FILE]: FILE_SOURCE_MAPPING.SYSTEM_FILE_ID,
  [FILE_SOURCE_MAPPING.EMAIL_FILE]: FILE_SOURCE_MAPPING.EMAIL_FILE_ID,
  [FILE_SOURCE_MAPPING.ZENDESK_FILE]: FILE_SOURCE_MAPPING.ZENDESK_FILE_ID,
  [FILE_SOURCE_MAPPING.TASK_FILE]: FILE_SOURCE_MAPPING.TASK_FILE_ID,
  [FILE_SOURCE_MAPPING.INTERCOM_FILE]: FILE_SOURCE_MAPPING.INTERCOM_FILE_ID,
  [FILE_SOURCE_MAPPING.FRESHDESK_FILE]: FILE_SOURCE_MAPPING.FRESHDESK_FILE_ID,
  [FILE_SOURCE_MAPPING.JIRA_FILE]: FILE_SOURCE_MAPPING.JIRA_FILE_ID,
  [FILE_SOURCE_MAPPING.SUCCESS_PLAN_FILE]: FILE_SOURCE_MAPPING.SUCCESS_PLAN_ID,
  [FILE_SOURCE_MAPPING.TICKET_FILE]: FILE_SOURCE_MAPPING.TICKET_FILE_ID,
};

export const FILE_MAX_SIZE_EXCEED_MESSAGE = 'File must be smaller than 25MB!';
export const FILE_MAX_SIZE_EXCEED_MESSAGE_FOR_EMAIL_ATTACHMENTS =
  'File attachments must be smaller than 25MB!';

export const FILE_TYPES = {
  img: {
    displayName: 'Image',
    types: ['png', 'jpg', 'jpeg', 'bmp', 'tif', 'tiff', 'gif', 'svg'],
  },
  ppt: { displayName: 'Presentation', types: ['ppt', 'pptx', 'key'] },
  doc: { displayName: 'Document', types: ['docx', 'doc', 'pages'] },
  pdf: { displayName: 'PDF', types: ['pdf'] },
  text: { displayName: 'Text', types: ['txt', 'ttf', 'json'] },
  xls: { displayName: 'Spreadsheet', types: ['xlsx', 'xls', 'numbers', 'csv'] },
  audio: {
    displayName: 'Audio',
    types: [
      'wav',
      'mp3',
      'weba',
      'aac',
      'm4a',
      'm4b',
      'ogg',
      'oga',
      'mmf',
      'awb',
      'au',
      'vox',
      'voc',
      'tta',
      'sln',
    ],
  },
  video: {
    displayName: 'Video',
    types: [
      'mp4',
      'wmv',
      'mov',
      'avi',
      'mkv',
      'flv',
      'webm',
      'html5',
      'avchd',
      'swf',
      'm4v',
      '3gp',
      'm4p',
      'f4v',
      'f4p',
      'f4a',
    ],
  },
  other: {
    displayName: 'Other',
    types: [
      'zip',
      'rar',
      'tar',
      'gzip',
      'eps',
      'ps',
      'psd',
      'ai',
      'dxf',
      'xps',
      'xml',
      'css',
      'php',
      'py',
      'ics',
      'html',
    ],
  },
};

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_FILES_PAGINATION = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};
